<template>

    <v-sheet :color="backgroundColor" :class="this.getFontClasses(backgroundColor)">

        <!-- EDIT MODE -->
        <div v-if="editMode" class="d-flex justify-space-between pa-4">

            <div class="align-self-center">
                <text-editor v-model="bannerTextModel"
                             hint="Download banner text">

                    {{ bannerTextModel }}

                </text-editor>
            </div>

            <text-editor v-model="bannerButtonModel"
                         hint="Download banner button text">

                <v-btn text :dark="isDarkColor(backgroundColor)" class="align-self-center">
                    <v-icon left>mdi-download</v-icon>
                    {{ bannerButtonModel }}
                </v-btn>

            </text-editor>
        </div>

        <!-- NON EDIT MODE -->
        <div v-if="!editMode" class="d-flex justify-space-between pa-4">
            <div class="align-self-center">
                {{ bannerText }}
            </div>
            <v-btn @click="downloadClicked"
                   text
                   class="align-self-center"
                   :dark="isDarkColor(backgroundColor)">
                <v-icon left>mdi-download</v-icon>
                {{ buttonText }}
            </v-btn>
        </div>

    </v-sheet>

</template>

<script>

import colorMixin from "@/components/mixins/colorMixin.js";
import TextEditor from "@/components/UI/TextEditor.vue";

export default {

    name: "MobileAppDownloadBanner",

    components: {
        TextEditor
    },

    mixins: [colorMixin],

    props: {

        bannerText: {
            type: String,
            required: false,
            default: 'NEW! Download the companion mobile app!'
        },

        buttonText: {
            type: String,
            required: false,
            default: 'Download mobile app'
        },

        subPanelId: {
            type: Number,
            required: true,
        },

        locale: {
            type: Object,
            required: true,
        },

        data: {
            type: Object,
            required: true,
        },

        backgroundColor: {
            type: String,
            required: true,
        },

        editMode: {
            type: Boolean,
            required: false,
            default: false,
        }
    },

    computed: {

        bannerTextModel: {
            get() {
                return this.bannerText;
            },
            set(value) {
                this.$emit('change:subPanelTranslations', {mobile_app_download_banner_text: value});
            }
        },

        bannerButtonModel: {
            get() {
                return this.buttonText;
            },
            set(value) {
                this.$emit('change:subPanelTranslations', {mobile_app_download_button_text: value});
            }
        },
    },

    methods: {
        downloadClicked() {
            this.sendToUrl('/mobile-app/' + this.subPanelId + '/' + this.locale.code);
        }
    }
}

</script>
